import { render } from "./SkillsList.vue?vue&type=template&id=31ce8350"
import script from "./SkillsList.vue?vue&type=script&lang=js"
export * from "./SkillsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__